import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { hydrologyGroups } from '../DataSets';

const HydrologyGroup = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="hydrologyGroup"
      name="hydrologyGroup"
      items={hydrologyGroups}
      label="Hydrology Group"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select hydrology group"
    />
  );
};

export default HydrologyGroup;
